/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для валют
   */
  app.Currencies = app.Collection.extend({
    
    url: app.entryScriptName + '/api/v3/currency/',
    /**
     * Устанавливает текущую валюту.
     *
     * @param {String} name имя валюты
     * @param {Boolean} [silent]
     */
    setCurrent: function (name, silent) {
      silent = silent || false;
      
      var tmpCurrent = this.findWhere({current: true});
      if (tmpCurrent) {
        tmpCurrent.set({current: false}, {silent: true});
      }

      this.findWhere({name: name}).set({current: true}, {silent: silent});
    },
    
    /**
     * Возвращает объект текущей валюты.
     *
     * @returns {app.Model} модель с текущей валютой
     */
    getCurrent: function () {
      return this.findWhere({current: true});
    }
  });

})();

}.call(window));